import { Tag, X } from 'lucide-react';
import React, { useEffect, useState } from 'react';
import { Button } from '@components/ui/button';
import { I18NText } from '@core/api/ChallengeClient';
import { StyledLocalizedTextField } from './styled-localized-textfield';

interface LabelToggleProps {
    label?: I18NText;
    onLabelChange: (value: I18NText | undefined) => void;
}

export const LabelToggle: React.FC<LabelToggleProps> = ({
    label,
    onLabelChange
}) => {
    const [isVisible, setIsVisible] = useState<boolean>(false);

    useEffect(() => {
        setIsVisible(!!(label && Object.keys(label).length > 0));
    }, []);

    const handleToggle = () => {
        if (isVisible) {
            onLabelChange(undefined);
        }
        setIsVisible(!isVisible);
    };

    if (isVisible) {
        return (
            <>
                <StyledLocalizedTextField
                    label="Label"
                    value={label || {}}
                    onChange={(value: I18NText) => onLabelChange(value)}
                />
                <Button
                    variant="outline"
                    size="xs"
                    className="rounded-full"
                    onClick={handleToggle}
                >
                    Remove label
                    <X />
                </Button>
            </>
        );
    }

    return (
        <Button
            variant="outline"
            size="xs"
            className="rounded-full"
            onClick={handleToggle}
        >
            <Tag />
            Add label
        </Button>
    );
};
